import { INFTSalesListFilter } from '../models/INFTSalesList'

export function NFTSalesFilterHelper(filter?: INFTSalesListFilter, nftCollection?: string,): string {
  let result = ''
  if (filter && filter.categoryId) {
    result = `category: ${filter.categoryId}`
  }

  if (nftCollection && nftCollection !== 'ALL') {
    result = `tokenContract: "${nftCollection.toLowerCase()}"`
  }
  return result
}
